import history from 'common/history';
import { uc } from 'common/uc';
import GcLayout from 'components/GcLayout';
import UserInfo from 'context/UserInfo';
import { ConfigProvider } from 'm-ui';
import zhCN from 'm-ui/es/locale/zh_CN';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Router, Switch } from 'react-router-dom';
import { fetchUserInfo } from 'store/global';
import './App.less';

const App = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchUserInfo());
  }, []);
  return (
    <div className="App" onClickCapture={uc.onRootClick}>
      <ConfigProvider
        locale={zhCN}
        getPopupContainer={(node) => {
          if (node) {
            return node.parentNode as HTMLElement;
          }
          return document.body;
        }}
      >
        <Router history={history}>
          <UserInfo>
            <Switch>
              <GcLayout />
            </Switch>
          </UserInfo>
        </Router>
      </ConfigProvider>
    </div>
  );
};

export default App;
